// global definitions of event keys, used in EventBus service

enum Events {
  SHOW_HOMEPAGE = 'show_homepage',
  SWITCH_LOCALE = 'switch_locale',
  OPEN_PROJECT_MODAL = 'open_project_modal',
}

export default Events;
